import React from "react";
import ViewRendering from "../components/ViewRendering";
import { renderingStuff, images } from "../utils";
import DashboardLayout from "../components/HOC/DashboardLayout";
import NewViewRendering from "../components/ViewRendering/NewViewRendering";

export default function IndentDashboard(props) {
  return (
    <div>
      <DashboardLayout name="Indent Dashboard" image={images.imgViewIndentForm}>
        <NewViewRendering
          {...props}
          data={renderingStuff.Indent_Dashboard_Links}
        />
      </DashboardLayout>

      {/* <h3 class="h3-responsive font-weight-bold text-center my-4">
				Indent Module's
			</h3>
			<div
				class="row"
				style={{
					justifyContent: 'center',
					textAlign: 'center',
					marginBottom: -30
				}}
			>
				<div class="col-md-8">
					<div class="md-form mb-0">
						<hr class="style-head" />
					</div>
				</div>
			</div>
			<ViewRendering
				centered={true}
				centerWidth={'20%'}
				data={renderingStuff.Indent_Dashboard_Links}
				mainHead={false}
			/> */}
    </div>
  );
}
